import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { useI18N } from '../../../libraries/i18n/hook'
import WizardTabs from '../../components/layout/WizardTabs'
import { CurrentUserContext } from '../../../libraries/auth'
import CloseButton from '../../components/form/CloseButton'
import { ANALYTICS_EVENTS, useAnalytics } from '../../../libraries/posthog'
import Loading from '../../components/layout/Loading'

type Props = { width?: 'md' | 'lg' }


const OnboardingMaster:React.FC<Props> = ({ width = 'md' }) => {
  const { t } = useI18N()
  const navigate = useNavigate()
  const [loading, setLoading] = React.useState(false)
  const { currentUser, refetchCurrentUser } = React.useContext(CurrentUserContext)
  const { trackEvent } = useAnalytics()

  if (!currentUser?.onboardingCompleted) {
    trackEvent(ANALYTICS_EVENTS.ONBOARDING_STARTED)
  }

  const tabs: Array<{ title: string, path: string }> = [
      { title: t('onboarding.personal.title'), path: '/onboarding/personal' },
      { title: t('onboarding.studies.title'), path: '/onboarding/studies' },
      { title: t('onboarding.preferences.title'), path: '/onboarding/preferences' },
      { title: t('onboarding.news.title'), path: '/onboarding/news' }
  ]

  const onClose = async () => {
    setLoading(true)
    await refetchCurrentUser()
    setLoading(false)
    navigate('/profile')
  }

  const showCloseButton = currentUser?.onboardingCompleted && currentUser?.linkedinSub

  if(loading) { return <Loading size='screen' /> }

  return (
    <>
      <div className='flex items-center'><WizardTabs tabs={tabs} />{showCloseButton && <CloseButton onClick={onClose} />}</div>
      <div className={`my-6 mx-auto ${width === 'lg' ? 'max-w-[968px]' : 'max-w-[580px]'}`}>
        <Outlet />
      </div>
    </>
  )
}

export default OnboardingMaster
